import type { ReportWorkbook } from '../api'
import { reportToWorkbook } from './excel-workbook'
import type { ExcelReport } from './excel-workbook'

/**
 * The workbook waiting in the preview dialog, if any.
 *
 * Module state rather than context: exports fire from mutation callbacks deep
 * in report screens, and `ExcelPreviewHost` — mounted once in the shell — is
 * the only reader.
 */
let current: ReportWorkbook | null = null
const listeners = new Set<() => void>()

function publish(next: ReportWorkbook | null) {
  current = next
  listeners.forEach((listener) => listener())
}

/** Opens a finished workbook (a server export) in the preview. Saving waits for the merchant. */
export function openExcelPreview(workbook: ReportWorkbook): void {
  publish(workbook)
}

/** Builds a report sheet in the browser, laid out as the server's, then opens it in the preview. */
export async function previewExcel(report: ExcelReport): Promise<void> {
  const blob = await reportToWorkbook(report)
  publish({ blob, fileName: report.fileName })
}

export function closeExcelPreview(): void {
  publish(null)
}

export function subscribeExcelPreview(listener: () => void): () => void {
  listeners.add(listener)

  return () => {
    listeners.delete(listener)
  }
}

export function currentExcelPreview(): ReportWorkbook | null {
  return current
}
